import { Stack, Typography } from '@mui/material';
import { CraneIcon } from 'app/icons';
import React from 'react';

export const CraneAngleSection = ({ angle }) => {
  return (
    <Stack direction='row' alignItems='center'>
      <CraneIcon degris={angle} />
      <Typography marginLeft='10px'>{angle}&deg;</Typography>
    </Stack>
  );
};
